<template>
  <div>
    <!-- 跟进 联系人-->
    <van-tabs v-model="activeName">
      <van-tab title="跟进记录" name="active_visit">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{listVisit.length}})条
            </div>
            <van-icon name="add" size="15" @click="handleaddvisit" v-hasPermi="['scrm:visit:add']" />
          </div>
          <div class="concat-list" v-if="listVisit.length > 0">
            <van-steps direction="vertical">
              <van-step  class="concat-item" v-for="visit in listVisit" :key="visit.visitId">
                 <div>
                    <!-- <span v-if="visit.boName" style="color:#2196f3">商机：{{visit.boName }}</span> -->
                    <span style="color:#191919;">回访内容： {{visit.content}}</span>
                    <span v-if="visit.contactName">{{visitTypeFormat(visit.visitType)}}&nbsp;&nbsp;[{{visit.contactName}}]</span>
                  </div>
                  <div class="content-footer ">
                    <span>{{visit.createTime}}</span>
                  </div>
              </van-step>
            </van-steps>
          </div>
          <empty v-else />
        </div>
      </van-tab>
      <!-- <van-tab title="产品报价" name="active_user">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{quotedPriceListData.length}})个产品报价
            </div>
          </div>
          <div class="concat-list" v-if="quotedPriceListData.length > 0">
            <div class="concat-item" v-for="quoted in quotedPriceListData" :key="quoted.boQuotedPriceId">
              <div class="content-header m-b-20">
                <div class="content-header_title">
                   <em class="boSty"><van-icon name="goods-collect"/></em><span>{{quoted.productName}}</span>
                </div>
              </div>
              <div class="content-main m-b-20" style="clear:both;">
                <span>数量：{{quoted.amount}}</span>
                <span>单位：{{quoted.unit == '1'?'小时':'天'}}</span>
                <span>单价：{{quoted.unitTprice}}</span>
                <span>折扣：{{quoted.discountMoney}}</span>
                <span>税减百分比：{{quoted.percentTax}}</span>
                <span>税直接减：{{quoted.directReduceTax}}</span>
                <span>总计：{{quoted.totalMoney}}</span>
              </div>
            </div>
          </div>
          <empty v-else />
        </div>
      </van-tab>
      <van-tab title="人员配置" name="active_pro">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{userConListData.length}})个人员配置
            </div>
          </div>
          <div class="concat-list" v-if="userConListData.length > 0">
            <div class="concat-item" v-for="user in userConListData" :key="user.boUserConId">
              <div class="content-header m-b-20">
                <div class="content-header_title">
                   <em class="boSty"><van-icon name="friends-o" /></em><span>{{user.title}}</span>
                </div>
              </div>
              <div class="content-main m-b-20" style="clear:both;">
                <span>人员数量：{{user.amount}}</span>
                <span>单价：{{user.unitTprice}}</span>
                <span>金额：{{user.payMoney}}</span>
              </div>
            </div>
          </div>
          <empty v-else />
        </div>
      </van-tab> -->
      <van-tab title="联系人" name="active_contract">
        <div class="concat-container">
          <div class="concat-header">
            <div class="title">
              共({{custContactOptions.length}})位联系人
            </div>
            <van-icon name="add" size="15" @click="handleAddContacts" v-hasPermi="['scrm:contact:add']" />
          </div>
          <div class="concat-list" v-if="custContactOptions.length > 0">
            <div class="concat-item" v-for="contact in custContactOptions" :key="contact.contactId">
              <div class="content-header m-b-20">
                <div class="content-header_title">
                  <em :class="contact.sex==1?'blue':contact.sex==2?'red':'gray'"><van-icon name="manager"/></em><span>{{contact.contactName}}</span>
                </div>
                <!-- <div>
                  <span v-if="custStatus !== '0'">
                    <van-icon name="edit" size="16" color="#1989fa" @click="editContract(contact.contactId)" v-hasPermi="['scrm:contact:edit']" />
                    <van-icon style=" padding-left:10px;padding-right:10px;" color="#ee0a24" name="close" size="16" @click="delContact(contact.contactId)" v-hasPermi="['scrm:contact:remove']" />
                  </span>
                </div> -->
              </div>
              <div class="content-main m-b-20" style="clear:both;">
                <!-- <span>性 别：{{contactSexFormat(contact.sex)}}</span> -->
                <span>姓名：{{contact.contactName}}</span>
                <span>性别：{{contactSexFormat(contact.sex)}}</span>
                <span>手机号：{{contact.mobile}}</span>
                <span>职务：{{contact.jobs}}</span>
                <!-- <span style="width: 100%;">邮箱：{{contact.email}}</span> -->
              </div>
            </div>
          </div>
          <empty v-else />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { Tabs, Tab, Icon, Button } from 'vant'
import Empty from '@/components/common/Empty'
export default {
  name: 'ContTab',
  props: {
    id: [String, Number],
    listVisitData: Array,
    custContactOptionsData: Array,
    custStatusData: String,
    quotedPriceList: Array,
    userConList: Array
  },
  components: {
    Empty,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  watch: {
    listVisitData: {
      immediate: true,
      handler(val) {
        this.listVisit = !val ? {} : val
      }
    },
    custContactOptionsData: {
      immediate: true,
      handler(val) {
        this.custContactOptions = !val ? {} : val
      }
    },
    quotedPriceList: {
      immediate: true,
      handler(val) {
        this.quotedPriceListData = !val ? {} : val
      }
    },
    userConList: {
      immediate: true,
      handler(val) {
        this.userConListData = !val ? {} : val
      }
    },
    custStatusData: {
      immediate: true,
      handler(val) {
        this.custStatus = !val ? {} : val
      }
    },
    id: {
      immediate: true,
      handler(val) {
        this.custId = !val ? {} : val
      }
    }
  },
  data() {
    return {
      custId: this.id,
      activeName: 'active_visit',
      listVisit: this.listVisitData,
      custContactOptions: this.custContactOptionsData,
      quotedPriceListData: this.quotedPriceList,
      custVisitTypeOptions: [],
      custStatus: this.custStatusData,
      userConListData: this.userConList,
      // 添加修改联系人title
      contactTitle: '',
      // 添加联系记录
      contactForm: {
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
        sex: null,
        mobile: null,
        qq: null,
        email: null,
        weixinSn: null,
        deptName: null,
        jobs: null,
        age: null,
        birthday: null,
        ideType: null,
        ideTypeName: null,
        ideSn: null,
        jobTitle: null,
        nickName: null,
        roleRelation: null,
        roleRelationName: null,
        intimacy: null,
        intimacyName: null,
        hobby: null,
        myUserid: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: '0',
        delFlag: null,
        orderNum: null,
        remark: null
      },
      // 回访记录
      visitForm: {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null
      },
      // 性别状态字典
      sexOptions: this.$store.state.dictOptions.sex || [],
      // 证件类型
      ideTypeOptions: [],
      // 角色关系
      roleRelationOptions: [],
      // 亲密程度
      intimacyOptions: [],
      addContactShow: false,
      dictOptions: {}
    }
  },
  created() {
    this.getDicts('crm_visit_type').then(res => {
      this.custVisitTypeOptions = res.data
    })
    this.getDicts('sys_user_sex').then(res => {
      this.sexOptions = res.data
    })
    // 商机来源
    this.getDicts('crm_bo_source').then(res => {
      this.dictOptions.boSourceOptions = this.setDictToInt(res)
    })
    // 商机状态
    this.getDicts('crm_bo_status').then(res => {
      this.dictOptions.boStatusOptions = this.setDictToInt(res)
    })
    // 分配状态
    this.getDicts('cms_distribute_status').then(res => {
      this.dictOptions.distributeStatusOptions = this.setDictToInt(res)
    })
  },
  mounted() {
  },
  methods: {
    // 性别
    contactSexFormat(sex) {
      return this.selectDictLabel(this.sexOptions, sex)
    },
    handleAddContacts() {
      this.$emit('handleAddContacts')
    },
    editContract(id) {
      // this.$emit('handleEditContract', id)
    },
    // 删除联系人
    delContact(contactId) {
      // this.$emit('delContact', contactId)
    },
    handleaddvisit() {
      this.$emit('handleaddvisit')
    },
    // 获取访问类型
    visitTypeFormat(visitType) {
      if (this.custVisitTypeOptions != null) {
        var visitName = this.selectDictLabel(this.custVisitTypeOptions, visitType)
        if (visitName != null && visitName != '') {
          return '[' + visitName + ']'
        }
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.dictOptions[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.concat-container {
  background-color: #fff;
  padding-bottom: 40px;
  .concat-header {
    padding: 20px;
    display: flex;
    flex-direction: inherit;
    justify-content: space-between;
    align-items: center;
    color: #1989fa;
    width: 90%;
    margin: 0 auto;
    .title {
      padding: 0;
      color: #666;
      font-size: 20px;
      font-weight: normal;
    }
  }
  .concat-list {
    overflow: scroll;
    .concat-item {
      border-bottom: 1px solid #eee;
      font-size: 26px;
      margin-left: 15px;
      margin-right: 15px;
      padding: 20px;
      // span:first-child {
      //   color: #000;
      // }
      span {
        color: #888;
        width: 100%;
        display: block;
        margin: 0.1rem 0;
      }
      .content-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .content-header_title {
          width: 70%;
          span {
            color: #000;
          }
          em{
            float: left;
            padding: 0.1rem 0.1rem 0 0;
          }
          .red{
            color: #f32d50;
          }
          .blue{
            color: #2d5bf3;
          }
          .gray{
            color: #50535c;
          }
          .boSty{
              float: left;
              padding: 0 0.1rem 0 0;
              font-size: 0.45rem;
              color:#108bed;
          }
        }

        .title {
          color: #ccc;
          font-size: 14px;
        }
      }
      .content-footer {
        margin-top: 20px;
        span {
          color: #888;
        }
      }
      span {
        font-size: 26px;
        word-break: break-all;
      }
    }
    .content-main {
      display: flex;
      flex-wrap: wrap;

      span {
        margin-bottom: 0.2rem;
        width: 48%;
        font-size: 26px;
        color: #888;
      }
    }
  }
}
.type_style {
  color: rgb(48, 153, 172);
}
.name_style {
  color: rgb(119, 150, 10);
}
.van-empty {
  background-color: #fff;
}
</style>
